import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/login': 'Sign in',
  '/signup': 'Create account',
  '/app': 'Records',
  '/app/dashboard': 'Dashboard',
  '/app/audit': 'Audit Trail',
  '/app/users': 'User Management',
};

const BASE = 'Cryopreservation Tool';

/** Keeps document.title in sync with the current route. Renders nothing. */
export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const label = TITLES[pathname];
    document.title = label ? `${label} · ${BASE}` : BASE;
  }, [pathname]);
  return null;
}
